import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React, { forwardRef, useImperativeHandle } from 'react'

const PageBodyOverlay = (props, ref) => {
  const [open, setOpen] = React.useState(false)
  const [loadingText, setLoadingText] = React.useState('Loading ...')

  useImperativeHandle(ref, () => {
    return {
      open: (loadingText) => {
        setOpen(true)
        setLoadingText(loadingText)
      },
      close: () => setOpen(false)
    }
  })

  return (
    <Backdrop
      sx={{ color: '#fff', position: 'absolute', top: 0, height: '100%', bottom: 0, left: 0, right: 0, zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <CircularProgress color='primary' sx={{ mr: 1 }} />
      <Typography>{loadingText}</Typography>
    </Backdrop>
  )
}

const PageBodyOverlayForwardedRef = forwardRef(PageBodyOverlay)

export default PageBodyOverlayForwardedRef
